'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatSize = function EditorFormatSize(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
  );
};
EditorFormatSize = (0, _pure2.default)(EditorFormatSize);
EditorFormatSize.displayName = 'EditorFormatSize';
EditorFormatSize.muiName = 'SvgIcon';

exports.default = EditorFormatSize;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/format-size.js
// module id = 2243
// module chunks = 0